import script from "./WarningGoogle.vue?vue&type=script&setup=true&lang=js"
export * from "./WarningGoogle.vue?vue&type=script&setup=true&lang=js"

import "./WarningGoogle.vue?vue&type=style&index=0&id=3ac9a8b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ac9a8b6"]])

export default __exports__